import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const About = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>About Us</h1>
        <br />
        <p className="fs-6 mt-2">
          The Bar Council of Uttarakhand is an Autonomous body established and
          Constituted in the Year 1999 - 2000 under the provisions of Advocates
          Act 1961.
          <br /> The Bar Association Dehradun is the professional body for
          Lawyers in Uttarakhand.
          <br />
          <br /> It provides representation and services for the Bar, and
          Guidance on issues of professional practice.
          <br /> The oldest bar of Dehradun. which is a professional
          organization that represents the interests of lawyers practicing in
          Dehradun, India. <br />
          <br />
          It is a voluntary association of advocates, which was established in
          2000 and has since been functioning as a platform for lawyers to
          network, share knowledge and expertise, and collectively work towards
          the betterment of the legal profession in Dehradun.
        </p>
      </section>
    </>
  );
};

export default About;
